import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/cohortModal";
import deltas from "../../actions/deltas";

const {SET_COHORT_MODAL_STATE} = deltas.actionTypes;

export default createStateReducer(states, states.CLOSED, SET_COHORT_MODAL_STATE);
